import { render, staticRenderFns } from "./HomeTrending.vue?vue&type=template&id=1d9036a6&scoped=true&"
import script from "./HomeTrending.vue?vue&type=script&lang=js&"
export * from "./HomeTrending.vue?vue&type=script&lang=js&"
import style0 from "./HomeTrending.vue?vue&type=style&index=0&id=1d9036a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9036a6",
  null
  
)

export default component.exports